import React from "react";
import { theme } from "../theme";

export const PageContainer = ({ children, style = {} }) => (
  <div
    style={{
      minHeight: "100vh",
      background: theme.colors.bg,
      padding: "24px",
      fontFamily: "Arial, sans-serif",
      color: theme.colors.text,
      ...style
    }}
  >
    <div
      style={{
        maxWidth: "1400px",
        margin: "0 auto"
      }}
    >
      {children}
    </div>
  </div>
);

export const Navbar = ({
  title = "Ecovanta",
  subtitle = "AI-powered ESG reporting",
  rightContent,
  style = {}
}) => (
  <div
    style={{
      background: theme.colors.card,
      border: `1px solid ${theme.colors.border}`,
      borderRadius: theme.radius.lg,
      boxShadow: theme.shadow.soft,
      padding: "18px 22px",
      marginBottom: "24px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: "16px",
      flexWrap: "wrap",
      ...style
    }}
  >
    <div>
      <div
        style={{
          fontSize: "24px",
          fontWeight: "800",
          color: theme.colors.text,
          letterSpacing: "-0.02em"
        }}
      >
        {title}
      </div>

      <div
        style={{
          marginTop: "4px",
          color: theme.colors.muted,
          fontSize: "14px"
        }}
      >
        {subtitle}
      </div>
    </div>

    {rightContent && <div>{rightContent}</div>}
  </div>
);

export const Section = ({ title, subtitle, children, action, style = {} }) => (
  <section
    style={{
      marginBottom: "28px",
      ...style
    }}
  >
    {(title || subtitle || action) && (
      <div
        style={{
          marginBottom: "16px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-end",
          gap: "16px",
          flexWrap: "wrap"
        }}
      >
        <div>
          {title && (
            <h2
              style={{
                margin: 0,
                fontSize: "26px",
                fontWeight: "800",
                color: theme.colors.text,
                letterSpacing: "-0.02em"
              }}
            >
              {title}
            </h2>
          )}

          {subtitle && (
            <p
              style={{
                margin: "6px 0 0",
                color: theme.colors.muted,
                fontSize: "14px"
              }}
            >
              {subtitle}
            </p>
          )}
        </div>

        {action && <div>{action}</div>}
      </div>
    )}

    {children}
  </section>
);

export const DashboardGrid = ({ children, min = "220px", style = {} }) => (
  <div
    style={{
      display: "grid",
      gridTemplateColumns: `repeat(auto-fit, minmax(${min}, 1fr))`,
      gap: "16px",
      ...style
    }}
  >
    {children}
  </div>
);

export const TwoColumnLayout = ({ left, right, style = {} }) => (
  <div
    style={{
      display: "grid",
      gridTemplateColumns: "minmax(360px, 520px) 1fr",
      gap: "24px",
      alignItems: "start",
      ...style
    }}
  >
    <div>{left}</div>
    <div>{right}</div>
  </div>
);